package one.healthium.content.navigation.content

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.insights.domain.content.ContentOptions
import one.healthium.insights.ui.content.ContentScreen
import one.healthium.insights.ui.personal_mealplan.PersonalMealPlanScreen
import one.healthium.meal_plans.domain.MealPlanInfoModel

@Composable
fun ContentContent(component: ContentComponent) {
    CompositionLocalProvider(
        LocalViewModelStoreOwner provides component
    ) {
        val isPersonalMealPlan = component.options is ContentOptions.MealPlan &&
                (component.options as ContentOptions.MealPlan).id == MealPlanInfoModel.PERSONAL_ID

        if (isPersonalMealPlan) {
            PersonalMealPlanScreen(eventDelegate = component)
        } else {
            ContentScreen(contentOptions = component.options, eventDelegate = component)
        }
    }
}
